module.exports = __webpack_public_path__ + "static/img/advantages-4.0edfc6bc.png";